import {
  OFFER_SELECTED,
  OFFER_MONTHLY_RATE_CALCULATED,
  DISPLAY_OFFERS,
  SERVICE_SELECTED,
  ACCESSORIES_SELECTED,
  ACCESSORIES_CODES_SELECTED,
  ACCESSORIES_CODES_COLOR_SELECTED,
  COLORS_SELECTED,
  FEES_UPDATE,
  FEES_RESET,
} from './constants';

/**
 *
 * @param offer
 * @returns {{offer: *, type: *}}
 */
export function offerSelected(offer) {
  return {
    type: OFFER_SELECTED,
    offer,
  };
}

/**
 *
 * @param monthlyRate
 * @returns {{monthlyRate: *, type: *}}
 */
export function calculateNewMonthlyRate(monthlyRate) {
  return {
    type: OFFER_MONTHLY_RATE_CALCULATED,
    monthlyRate,
  };
}

/**
 *
 * @returns {{fees: *}}
 */
export function resetFees() {
  return {
    type: FEES_RESET
  };
}

/**
 *
 * @param fees
 * @returns {{fees: *, type: *}}
 */
export function updateFees(fees) {
  return {
    type: FEES_UPDATE,
    fees,
  };
}

/**
 *
 * @param display
 * @returns {{display: *, type: *}}
 */
export function displayOffers(display = true) {
  return {
    type: DISPLAY_OFFERS,
    display,
  };
}

/**
 *
 * @param services
 * @returns {{services: *, type: *}}
 */
export function selectServices(services) {
  return {
    type: SERVICE_SELECTED,
    services,
  };
}

/**
 *
 * @param accessories
 * @returns {{services: *, type: *}}
 */
export function selectAccessories(accessories) {
  return {
    type: ACCESSORIES_SELECTED,
    accessories,
  };
}

/**
 * @param colors
 * @returns {{accessories: *, type: string}}
 */
export function selectColors(colors) {
  return {
    type: COLORS_SELECTED,
    colors,
  };
}

/**
 * @param codes
 * @returns {{codes, type: string}}
 */
export function selectAccessoriesCodes(codes) {
  return {
    type: ACCESSORIES_CODES_SELECTED,
    codes,
  };
}

/**
 * @param codes
 * @returns {{codes, type: string}}
 */
export function selectColorCodes(codes) {
  return {
    type: ACCESSORIES_CODES_COLOR_SELECTED,
    codes,
  };
}
